import {NodeSpec} from 'prosemirror-model';

export let text_spec: NodeSpec = {
  group: 'inline',
};
